import { Identity } from '../../../core/type';

export interface PaymentMethod extends Identity {
  name: string
}

export const ALLOWED_PAYMENT_METHODS: readonly string[] = [
  'AX',
  'CA',
  'CK',
  'DBT',
  'DIS',
  'MC',
  'PP',
  'VS',
  'WT',
] as const
